import axios from 'axios';
import { tpoGenUrls } from 'config/urls';
import { queryClient } from 'services/reactQueryService';
import { tpoGenKeys } from '../../utils/tpoGenQueryKeys';

const fetchPlanListApi = async (
    planningGroupId: string,
    showMyPlans: boolean,
    filters: Record<string, any>,
    sortBy: string,
    sortOrder: string,
    limit: number,
) => {
    const currentUser = localStorage.getItem('email');
    const response = await axios(tpoGenUrls.getPlanList, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        data: {
            planning_group_id: planningGroupId,
            sort_by: sortBy,
            sorting_order: sortOrder,
            limit,
            offset: 0,
            search_keyword: '',
            user_id: currentUser,
            my_plans_only: showMyPlans,
            filters: filters,
        },
    });
    return response.data;
};

const fetchPlanList = async (
    planningGroupId: string,
    showMyPlans: boolean,
    filters: Record<string, any>,
    sortBy: string,
    sortOrder: string,
    limit: number,
) => {
    const data = await queryClient.fetchQuery({
        queryKey: tpoGenKeys.planList(planningGroupId, showMyPlans, filters, sortBy, sortOrder, limit),
        queryFn: () => fetchPlanListApi(planningGroupId, showMyPlans, filters, sortBy, sortOrder, limit),
    });
    return data;
};

export default fetchPlanList;
